import * as React from "react";

import { useCurrentProjectContext } from "@v2/contexts/CurrentProjectContext";
import { WorkspaceDashboardContext } from "@v2/contexts/WorkspaceDashboardContext";
import { exhaustiveSwitch } from "replo-utils/lib/misc";

/**
 * Whether the current user may buy add-ons or change the workspace plan, or
 * null while that is still unknown. Workspace viewers and project guests can't.
 * Without a project role, only a refused workspace fetch means no access, so a
 * transient failure doesn't lock a member out.
 */
export function useCanManageWorkspaceBilling(): boolean | null {
  const workspaceContext = React.useContext(WorkspaceDashboardContext);
  const { userRole } = useCurrentProjectContext();

  if (userRole) {
    return exhaustiveSwitch({ type: userRole })({
      superuser: () => true,
      workspaceOwner: () => true,
      workspaceMember: () => true,
      workspaceViewer: () => false,
      projectMember: () => false,
    });
  }
  if (workspaceContext?.isNoAccess) {
    return false;
  }
  return workspaceContext?.workspace ? true : null;
}
